module.exports = __webpack_public_path__ + "static/media/latptop.9015a719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latptop.jpg
// module id = 759
// module chunks = 1 3